import ProfileButton from "./ProfileButton";
import PlaneIcon from "../Icons/PlaneIcon";
import appSettings from "../../settings/appSettings";

export function VisitMeButton(props) {
  const { urls } = appSettings;
  const visitMeUrl = `${urls.core}/sponsor-a-child/support-center/visit-sponsored-child`;

  return (
    <ProfileButton 
      classList="profile-button__visit-me"
      requires={["commitment"]}
      ctaUrl={visitMeUrl}
      icon={<PlaneIcon />}
      newTab={true}
      {...props}
    >
      Visit Me
    </ProfileButton>
  );
}

export default VisitMeButton;